import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';

import { StatContainer, StatHeader, StatValue } from './styles';

type Props = {
    isTeam?: boolean;
    messageAbbrev: string;
    messageName: string;
    value?: number | string;
};

const StatDisplay: FC<Props> = ({ isTeam, messageAbbrev, messageName, value }) => {
    const intl = useIntl();
    return (
        <StatContainer>
            <StatValue $isTeam={isTeam}>
                {value ?? <FormattedMessage {...commonMessages.statsDescriptions.noStatIndicator} />}
            </StatValue>
            <StatHeader title={CoreUtils.safeFormatMessage(intl, commonMessages.statsDescriptions.long[messageName])}>
                <CoreUtils.SafeFormattedMessage
                    message={commonMessages.statsDescriptions.abbreviations[messageAbbrev]}
                />
            </StatHeader>
        </StatContainer>
    );
};

export default StatDisplay;
